const KatalReady = (window.KatalReady = window.KatalReady || {});

/**
 * Fires a custom event with the given component name as the detail. Adds the
 * component name to the global `KatalReady` object.
 * @param componentName The name of the component that is ready.
 * @param eventType The name of the event to fire.
 */
export function fireReadyEvent(componentName: string, eventType: string) {
  if (KatalReady[componentName]) {
    return;
  }

  const event = new CustomEvent(eventType, {
    bubbles: true,
    detail: componentName,
  });

  KatalReady[componentName] = true;
  document.dispatchEvent(event);
}
